import {
    generateTasksFilteredArray as generateTasksFilteredArrayDiagram,
} from '@process-advisor/process-miner/processMiner/processMiner';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';

export type Props = ApiMethodBase & {
    type: string;
    variantPaneVariants: boolean;
    variant?: number;
    activity?: number,
    from?: number,
    to?: number,
    discovery_rule_id?: number,
    groups?: any[]
    task? : string
};

export async function generateTasksFilteredArray ({
    type, variantPaneVariants, activity, variant, from, to, discovery_rule_id, groups, task,
    eventEmitter,
}: Props) {
    generateTasksFilteredArrayDiagram(type, variantPaneVariants, variant, activity, from, to, discovery_rule_id, groups, task);
};
